import { CheckboxGroup } from 'components/ControlledInputs/CheckboxGroup';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { ReactElement } from 'react';

interface Props {
  choices: { label: ReactElement; value: string }[];
  filterField: string;
  title: string;
  queryKey: string;
}

export const FilterCheckList = ({ filterField, title, queryKey, choices }: Props) => {
  const { setParameters, parameters: filters } = useSearchParameters(queryKey);

  const handleChange = (values: string[]) => {
    setParameters({ ...filters, [filterField]: values.filter((item) => item !== '').join(',') });
  };

  return (
    <CheckboxGroup
      label={title}
      data={choices}
      onChange={handleChange}
      value={filters[filterField] ? filters[filterField].split(',') : []}
      spacing={'xs'}
    />
  );
};
